(function () {
  /* Slick needs jQuery. Both are loaded from cdnjs only if the theme doesn't already have them. */
  const JQUERY_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js';
  const SLICK_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js';
  const scriptPromises = {};

  function loadScript(src) {
    if (!scriptPromises[src]) {
      scriptPromises[src] = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.head.appendChild(script);
      });
    }
    return scriptPromises[src];
  }

  function loadSlick() {
    const jqueryReady = window.jQuery ? Promise.resolve() : loadScript(JQUERY_SRC);
    return jqueryReady.then(() => (window.jQuery.fn.slick ? null : loadScript(SLICK_SRC))).then(() => window.jQuery);
  }

  if (customElements.get('shop-by-color')) return;

  class ShopByColor extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sbc__track');
      if (!this.track || this.track.children.length === 0) return;

      loadSlick()
        .then(($) => {
          if (!this.isConnected) return;
          this.$ = $;
          this.init();
        })
        .catch((error) => console.error('[Shop by color]', error));
    }

    disconnectedCallback() {
      if (this.$track && this.$track.hasClass('slick-initialized')) {
        this.$track.slick('unslick');
      }
    }

    init() {
      const $ = this.$;
      const data = this.dataset;
      const prevButton = this.querySelector('[data-sbc-prev]');
      const nextButton = this.querySelector('[data-sbc-next]');
      const dotsWrap = this.querySelector('.sbc__dots');
      const hasArrows = Boolean(prevButton && nextButton);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const desktop = parseInt(data.slidesDesktop, 10) || 5;
      const tablet = parseInt(data.slidesTablet, 10) || 3;
      const mobile = parseInt(data.slidesMobile, 10) || 2;

      this.$track = $(this.track);
      this.$track.slick({
        slidesToShow: desktop,
        slidesToScroll: 1,
        infinite: data.loop === 'true',
        autoplay: data.autoplay === 'true',
        autoplaySpeed: parseInt(data.autoplaySpeed, 10) || 4000,
        pauseOnHover: true,
        speed: reduceMotion ? 0 : 500,
        cssEase: 'ease',
        rows: 0, // keep our markup as-is (no extra wrapper divs)
        swipeToSlide: true,
        touchThreshold: 8,
        arrows: hasArrows,
        prevArrow: hasArrows ? prevButton : undefined,
        nextArrow: hasArrows ? nextButton : undefined,
        dots: Boolean(dotsWrap),
        appendDots: dotsWrap ? $(dotsWrap) : undefined,
        // Breakpoints match the CSS: below 1100px = tablet, below 750px = mobile
        responsive: [
          { breakpoint: 1100, settings: { slidesToShow: tablet } },
          { breakpoint: 750, settings: { slidesToShow: mobile } },
        ],
      });

      // Theme editor: jump to the card whose block is selected
      if (window.Shopify && Shopify.designMode) {
        const items = Array.from(this.querySelectorAll('.sbc__item:not(.slick-cloned)'));
        this.addEventListener('shopify:block:select', (event) => {
          const index = items.indexOf(event.target);
          if (index === -1) return;
          this.$track.slick('slickPause');
          this.$track.slick('slickGoTo', index);
        });
        this.addEventListener('shopify:block:deselect', () => {
          if (data.autoplay === 'true') this.$track.slick('slickPlay');
        });
      }
    }
  }

  customElements.define('shop-by-color', ShopByColor);
})();
